import classNames from 'classnames';
import { parsingAI } from '@/utils/audioPlay';
import { IPictureCompletionProp, IlistItem } from '@/utils/ctype';
import { UNANSWEREDWRAP } from '@/utils/contant';
import Analysis from '../../../components/Analysis';
import Radio from '../../../components/Radio';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';


// type reading 3



export default function SentenceParagraphInformationMatchingQuestion(props: IPictureCompletionProp){
  const { data, groupId, answerMap, saveAnswerHandle, isAI, currentFocus, type, keyIndex, answerAllText, setFocusIndexHandle } = props;
  const { list, optionLetters: letterArr, optionLettersHtml: letterArrHtml } = data;

  console.log('isAI', isAI);

  const createAIType = (answer: string, item: IlistItem, letter: string) => {
    if (!isAI) {
      return null;
    }
    // display_answer 为ABC 我拿到的answerData
    if (letter === item?.display_answer) {
      return 'success';
    } else if (letter === answer) {
      return 'fail';
    } else {
      return 'normal';
    }
  };

  return (
    <div className={style.answerBox}>
      <table className={style.table}>
        <thead>

          <th className={style.th}></th>{letterArrHtml?.map((item: string, index: number) =>{
            return (
              <th key={item} className={style.th}>
                <div style={{textAlign: 'center'}} data-key={`~question.question.${keyIndex}.optionLetters.${index}`}>
                  <HtmlParser htmlString={item}></HtmlParser>
                </div></th>
            );
          })}
        </thead>
        <tbody>
          {list.map((item, itemIndex: number) => 
          {
            const {id} = item;
            const key = `${groupId}_${type}_${id}`;
            const number = item.number;
            const answerData = answerMap[`${groupId}_${type}_${item.id}`];
            const answer = answerData && answerData[0];
            return (
              <tr key={number} className={style.row}>
                <td className={style.question}>
                  <div className={classNames(style.questionText, `question${number}`)} id={`question${number}`}>
                    <span className={classNames(style.questionNumber, currentFocus === number && style.active)} data-key={`$question.question.${keyIndex}.list.${itemIndex}.number`}><HtmlParser htmlString={item.numberHtml || item.number}></HtmlParser></span>
                    <span className={style.questionTitle} data-key={`question.question.${keyIndex}.list.${itemIndex}.title`}><HtmlParser htmlString={item.title} ></HtmlParser></span>
                    {isAI && !answer ? <span className={classNames(style.fail, style.answerText)} data-key={`answerAllText.${number-1}`}><HtmlParser htmlString={answerAllText[number - 1]}></HtmlParser></span> : null }
                    {isAI ? <Analysis onClick={() => {parsingAI(item);}}></Analysis> : null}
                  </div>
                </td>
                {
                  letterArr?.map((letter: string) => {
                    return (
                      <td key={letter} className={classNames(style.radioTd, isAI ? '' : style.hoverBack)}>
                        <label className={style.label}>
                          <Radio type={createAIType(answer, item, letter)} name={`radio${number}`}
                            className={style.radio} checked={answerMap[key]&& answerMap[key][0] === letter}
                            onChange={()=> {saveAnswerHandle(item.number, {group_id: groupId, type, id, answer: [letter]});}}
                            onFocus={() => {setFocusIndexHandle&&setFocusIndexHandle(item.number);}}/>
                        </label>
                      </td>
                    );
                  }
                  )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}